require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./interview-kerry-wallace.json") })
        }
      }, "path---interview-kerry-wallace");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---interview-kerry-wallace!./.cache/json/interview-kerry-wallace.json
// module id = 685
// module chunks = 231608221292675